

const Input = ({ label, id, type, value, onChange,isLast,disable}) => {
    return (
        <div className="relative h-[72px]">
            {disable?
            <input disabled className={`w-full peer absolute bottom-0 bg-bright-gray/50 rounded-xl py-3 px-4 focus:outline-primary outline-primary ${isLast && "bg-primary/10 text-primary"} `} id={id} type={type} value={value!='0'?value:''} onChange={onChange} />
         :  <input  className={`w-full peer absolute bottom-0 bg-bright-gray/50 rounded-xl py-3 px-4 focus:outline-primary outline-primary ${isLast && "bg-primary/10 text-primary"} `} id={id} type={type} value={value!='0'?value:''} onChange={onChange} />
        }
            <label className="peer-focus:text-primary text-chinese-black/70  xl:ml-4 font-medium text-[10px] sm:text-xs md:text-sm">{label}</label>
        </div>
    );
};

export default Input;